/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const SquareArrowRightEnter = [
  ["path", { d: "m10 16 4-4-4-4" }],
  ["path", { d: "M3 12h11" }],
  ["path", { d: "M3 8V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" }]
];

export { SquareArrowRightEnter as default };
//# sourceMappingURL=square-arrow-right-enter.js.map
